<div class="table-scroll execucao-view">
  <div class="alert alert-danger m-b-xl" *ngIf="warnings?.length > 0">
    <h5>Inconsistências: </h5>
    <ol>
      <li *ngFor="let warning of warnings">{{ warning }}</li>
    </ol>
  </div>
  <div class="table-scroll" *ngIf="execucaoList?.length">
    <mat-accordion  class="" multi [togglePosition]="'before'">
      <ng-container *ngFor="let items of execucaoList; let ind = index">
        <mat-expansion-panel class="mb-2"  *ngIf="items?.id != 'project'">
          <mat-expansion-panel-header>
            <mat-panel-title class="d-flex justify-content-between" [title]="">
              <div class="max-title">
                <h3>{{ items?.name }}</h3>
              </div>
              <div class="d-flex justify-content-end" *ngIf="accordion">
                <button class="btn btn-font-icon ms-1" type="button" (click)="accordion?.openAll()"
                  alt="Selecionar todos" title="Abrir todos">
                  expand
                </button>
                <button class="btn btn-font-icon ms-1" type="button"  (click)="accordion?.closeAll()"
                  alt="Selecionar todos" title="Fechar todos">
                  compress
                </button>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-accordion #accordion="matAccordion" class="" multi [togglePosition]="'before'">
            <ng-container *ngFor="let execucao of items.list; let ind = index">
              <mat-expansion-panel class="mb-2">
                <mat-expansion-panel-header>
                  <div>
                    <h3>{{ execucao?.label ?? 'Geral' }}</h3>
                  </div>
                </mat-expansion-panel-header>
                <ng-container *ngTemplateOutlet="templateExec; context: { $implicit: { execucao: execucao?.execucao_orcamentaria_resultados_totais, isProject: false } }">
                </ng-container>
              </mat-expansion-panel>
            </ng-container>
          </mat-accordion>
        </mat-expansion-panel>
        <mat-expansion-panel class="mb-2"  *ngIf="items?.id == 'project'">
          <mat-expansion-panel-header>
            <mat-panel-title class="d-flex justify-content-between" [title]="">
              <div class="max-title">
                <h3>{{ items?.name }}</h3>
              </div>
            </mat-panel-title>
          </mat-expansion-panel-header>
          <ng-container *ngTemplateOutlet="templateExec; context: { $implicit: { execucao: items.list, isProject: true } }">
          </ng-container>
          
        </mat-expansion-panel>
      </ng-container>
    </mat-accordion>

    <div class="hr-line-dashed"></div>
    <div class="form-group row d-flex justify-content-end" *ngIf="permissionExec?.canSave && permissionExec?.can_see_forecast">
      <div class="col-sm-8 col-sm-offset-2 d-flex justify-content-end">
        <button class="btn btn-primary btn" type="submit">Salvar</button>
      </div>
    </div>
  </div>
</div>
<app-loading [loader]="isLoading"></app-loading>

<ng-template #templateExec let-data>
  <form [formGroup]="form"  (ngSubmit)="salvar()">
    <div class="system-table table-container table-form">
      <div class="system-table-conteiner system-table-form-conteiner">
        <table>
          <thead>
            <tr>
              <th class="title-scroll">Período</th>
              <th class="text-center" *ngIf="data.isProject">Previsão de Desembolso Acumulado</th>
              <!--<th>Previsto Acumulado</th>-->
              <th class="text-center">Empenhado Acumulado</th>
              <th class="text-center">Liquidado Acumulado</th>
              <th class="text-center">
                Pago Acumulado
                <button matButton="elevated" #tooltip="matTooltip"
                    matTooltip='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                    class="btn-help"
                    matTooltipHideDelay="200"
                    aria-label='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                    >
                  question_mark
                </button>
              </th>
              <th class="text-center">Liquidado Exercício Anterior</th>
              <th class="text-center">
                Pago Exercício Anterior
                <button matButton="elevated" #tooltip="matTooltip"
                    matTooltip='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                    class="btn-help"
                    matTooltipHideDelay="200"
                    aria-label='No sistema FPE, refere-se à soma dos valores dos campos "Pago" e "Pagamento Regularizado"'
                    >
                  question_mark
                </button>
              </th>
            </tr>
          </thead>
          <ng-container *ngIf="data.isProject">
            <tbody formArrayName="previsao">
              <tr *ngFor="let month of months; let i = index" [formGroupName]="i">
                <ng-container *ngIf="i > 0">
                  <td class="text-center">{{ month }}</td>
                  <ng-container *ngIf="monthExecution(i, data.execucao) as exec">
                    <td class="text-center"  *ngIf="data.isProject">
                      <input type="text" class="form-control text-right" formControlName="valor_previsao_desembolso" (keyup)="formatarMedidaFisica(i, 'valor_previsao_desembolso', 'previsao')">
                    </td>
                    <ng-container *ngTemplateOutlet="templateLine; context: { $implicit: {exec:exec} }">
                    </ng-container>
                  </ng-container>
                </ng-container>
              </tr>
            </tbody>
          </ng-container>
          <ng-container *ngIf="!data.isProject">
            <tbody>
              <tr *ngFor="let month of months; let i = index">
                <td class="text-center">{{ month }}</td>
                <ng-container *ngIf="monthExecution(i, data.execucao) as exec">
                  <ng-container *ngTemplateOutlet="templateLine; context: { $implicit: {exec:exec} }">
                  </ng-container>
                </ng-container>
              </tr>
            </tbody>
          </ng-container>
        </table>
      </div>
    </div>
    
    <div class="d-flex justify-content-end"  *ngIf="data.isProject && permissionExec?.canSave">
      <button class="btn btn-primary btn" type="submit">Salvar</button>
    </div>
  </form>
</ng-template>
<ng-template #templateLine let-data>
  <td class="text-center">{{(data.exec.empenhado ?? 0)| number:'1.2-2'}}</td>
  <td class="text-center">{{(data.exec.liquidado ?? 0)| number:'1.2-2'}}</td>
  <td class="text-center">{{(data.exec.pago ?? 0)| number:'1.2-2'}}</td>
  <td class="text-center">{{(data.exec.liquidado_exercicio_anterior ?? 0)| number:'1.2-2'}}</td>
  <td class="text-center">{{(data.exec.pago_exercicio_anterior ?? 0)| number:'1.2-2'}}</td>
</ng-template>